// Dane Sprzedawcy — jedno źródło dla regulaminu, polityki prywatności, stopki i strony kontaktu.
export const COMPANY = {
  name: "Digital Liberty Dariusz Zarobski",
  owner: "Dariusz Zarobski",
  street: "ul. Żabia 19 lok. 13",
  postal: "87-800",
  city: "Włocławek",
  region: "woj. kujawsko-pomorskie",
  nip: "8882895947",
  regon: "545802306",
  email: "kontakt@digilib.store",
  // telefon podajemy wyłącznie tam, gdzie wymaga go prawo: informacje przed zawarciem umowy (Regulamin § 1, art. 12 ust. 1 pkt 3 UPK)
  // i potwierdzenie zawarcia umowy w e-mailu (art. 21 UPK); podstawowy kanał obsługi to e-mail
  phone: "+48 513 313 814",
  site: "digilib.store",
  bank: "42 1020 5170 0000 1602 0491 9843", // PKO Bank Polski — przelew tradycyjny
};

export const COMPANY_ADDRESS = `${COMPANY.street}, ${COMPANY.postal} ${COMPANY.city}`;
export const COMPANY_LINE = `${COMPANY.name} · ${COMPANY_ADDRESS} · NIP ${COMPANY.nip} · REGON ${COMPANY.regon}`;
export const LEGAL_UPDATED = "27 października 2026 r.";
